/**
 * @file header-state.js
 */

export default {
    smartPassport: 'https://passport.baidu.com/v2/?login&tpl=pcs&u=',
    smartPassportExit: 'https://passport.baidu.com/?logout&u=',
    mpPassport: 'https://wappass.baidu.com/passport/?login&tpl=wimn&sms=1&regtype=1&u=',
    mpPassportExit: 'https://wappass.baidu.com/?logout&u=',
    smartProgram: 'https://smartprogram.baidu.com/developer/index.html',
    openSourceProgram: 'https://ossunion.baidu.com/opensource/index.html',
    // 开源文档
    openSourceDocs: 'https://ossunion.baidu.com/opensourcedocs/introduction/principle/register/',
    smartManager: 'https://smartprogram.baidu.com/developer/applist.html',
    logo: require('@/assets/images/app_logo_new.png'),
    forum: require('@/assets/images/logo_forum.png'),
    docs: require('@/assets/images/logo_docs.png'),
    avatar: require('@/assets/images/avatar.png'),
    messageNum: 0,
    userName: '',
    userNo: '',
    isLogin: false,
    isBanned: 0,
    isOfficial: 0,
    permission: {},
    isShow: false,
    isOpen: false,
    isOutside: false,
    isVcr: false,
    isFakeOfficial: false,
    relationVirtualUserList: [],
    tips: '请输入1-30个字符的昵称，不得包含色情、违法等敏感信息',
    normalTips: '请输入1-30个字符的昵称，不得包含色情、违法等敏感信息',
    shortTips: '昵称过短,请输入1-30个字符的昵称，不得包含色情、违法等敏感信息',
    longTips: '昵称过长,请输入1-30个字符的昵称，不得包含色情、违法等敏感信息',
    fakeOfficialTips: '昵称中含有明显的官方化词汇，请重新设置',
    docNavList: [{
        name: '介绍',
        link: '/docs/introduction/enter_application/'
    }, {
        name: '设计',
        link: '/docs/design/overview/introduction/'
    }, {
        name: '开发',
        link: '/docs/develop/fuctionlist/list/'
    }, {
        name: '数据',
        link: '/docs/data/concept/'
    }, {
        name: '运营',
        link: '/docs/operations/specification/'
    }, {
        name: '第三方平台',
        link: '/docs/third/create/'
    }],
    docNavOther: [{
        name: '服务市场',
        link: 'https://smartprogram.baidu.com/developer/servicemarket.html'
    }, {
        name: '社区',
        link: 'https://smartprogram.baidu.com/forum/'
    }],
    searchSource: ['forum', 'docs']
};
